import './App.css';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom'
import Home from './pages';
import BrainzShop from './pages/brainzshop';

export const DISCORD_URL = "https://discord.gg/Wk77azYrsu";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/" component={Home} exact />
        <Route path="/brainzshop" component={BrainzShop} exact />
      </Switch>
    </Router>
  );
}

export default App;
